import { useTranslation } from 'react-i18next';
import { CardV2 } from "../../../components/CardV2/CardV2";
import { DraggableList } from "../../../components/DraggableList/DraggableList";

interface RequestFormSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function RequestFormSection({ contractTemplate, updateContractTemplate }: RequestFormSectionProps) {
  const { t } = useTranslation();

  return (
    <CardV2>
      <div className="p-4">
        <div className="text-xs text-muted-foreground mb-4">
          {t('commission_contract_template.form_conditions_hint') || 'These conditions will be shown to brides when they fill out the request form to sell their dresses.'}
        </div>
        <DraggableList
          items={contractTemplate.formConditions || []}
          setItems={items => updateContractTemplate({ formConditions: items })}
          placeholder={t('commission_contract_template.form_conditions.placeholder') || 'Add a condition for the request form...'}
          buttonText={t('commission_contract_template.form_conditions.add_button') || 'Add condition'}
        />
      </div>
    </CardV2>
  );
}
